import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as firebase from 'firebase';
import { firebaseToRealArray } from './helpers/fireHelper';
import VisibilitySensor from 'react-visibility-sensor'
import Iframe from './Iframe';

class DisplayFrame extends Component {
  constructor(props) {
    super(props)
    this.state = {
      envelope: null
    }
    this.deleteEnvelope = this.deleteEnvelope.bind(this);
    this.fullEnvelopeRef = firebase.database().ref().child('/full-envelopes/' + props.envelope.key);
  }

  componentDidMount() {
    // MOVE THIS TO FIREHELPER
    this.fullEnvelopeRef.once('value', function(snap) {
      var envelope = snap.val();
      var newTable = firebaseToRealArray(envelope.table);
      envelope.table = newTable;
      envelope.libraries = JSON.parse(envelope.libraries)
      this.setState({ envelope })
    }.bind(this))
  }

  deleteEnvelope(e) {
    e.preventDefault();
    // console.log(firebase.auth().currentUser.uid);
    if (firebase.auth().currentUser === null) {
      console.warn('NOT AUTHENTICATED - NOT ALLOWED TO PERFORM DELETE ACTION')
    } else {
      var k = this.props.envelope.key;
      if (window.confirm(`Do you really want to delete this envelope, `
          + `called "${this.props.envelope.name}"?`)) {
        this.props.onEnvelopeDelete(k, this.fullEnvelopeRef);
      } else {
        // Delete action cancelled
      }
    }
  }

  componentWillUnmount() {
    this.fullEnvelopeRef.off();
  }

  render() {
    return (
      <VisibilitySensor>
        {({isVisible}) => {
          if (isVisible) {
            if (this.state.envelope === null) {
              return (
                <div className="iframeWrapper">
                  <div className="title">{this.props.envelope.name || 'Unnamed'}</div>
                  <div className="display-frame-paragraph">
                    <br/>
                    <br/>
                    <img src="./envelopeLogoGreen.png" alt="" height="120">
                    </img>
                  </div>
                  <div className="iframeBlocker">
                    <Link to={{ pathname: `/edit/${this.props.envelope.key}`, envelope: this.props.envelope }} >
                    </Link>
                  </div>
                </div>
              );
            }
            else {
              return (
                <div className="iframeWrapper" onContextMenu={this.deleteEnvelope}>
                  <div className="title">{this.props.envelope.name || 'Unnamed'}</div>
                  <Iframe key={this.props.envelope.key} env={this.state.envelope}/>
                  <div id={`iframeBlocker${this.props.idnr}`} className="iframeBlocker">
                    <Link to={{ pathname: `/edit/${this.props.envelope.key}`, envelope: this.props.envelope }} >
                      <p id={`descr${this.props.idnr}`} className="display-frame-paragraph"><br/></p>
                    </Link>
                  </div>
                </div>
              )
            }
          }
          else {
            return (
              <div className="iframeWrapper">
                <div className="title">{this.props.envelope.name || 'Unnamed'}</div>
                <div className="display-frame-paragraph">
                  <br/>
                  <br/>
                  <img src="./envelopeLogoRed.png" alt="" height="120">
                  </img>
                </div>


                <div className="iframeBlocker">
                  <Link to={{ pathname: `/edit/${this.props.envelope.key}`, envelope: this.props.envelope }} >

                  </Link>
                </div>
              </div>
            );
          }
        }}
      </VisibilitySensor>
    );
  }
}

export default DisplayFrame;



// WEBPACK FOOTER //
// ./src/DisplayFrame.js